import { cx } from "shared/utils";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { BoomAvatarGlyph, ChannelAvatar } from "./ChannelAvatar";
import { SyndicationState } from "./syndication";

const AVATAR_CLASS =
  "-ml-1.5 inline-flex size-5 shrink-0 items-center justify-center overflow-hidden rounded-full ring-2 ring-content-1000-inverted first:ml-0";

export const ChannelAvatarRow = ({
  syndication
}: {
  syndication: SyndicationState;
}) => {
  const channels = [
    { id: IntegrationId.ZUMPER, active: syndication.zumper },
    { id: IntegrationId.ZILLOW, active: syndication.zillow },
    { id: IntegrationId.APARTMENTS_COM, active: syndication.apartmentsCom },
    { id: IntegrationId.DWELLSY, active: syndication.dwellsy }
  ].filter((channel) => channel.active);

  return (
    <span className="inline-flex w-fit items-center rounded-full bg-alpha-40 px-2 py-1">
      <span className={cx(AVATAR_CLASS, "bg-primary-500 text-white")}>
        <BoomAvatarGlyph />
      </span>
      {channels.map((channel) => (
        <span key={channel.id} className={AVATAR_CLASS}>
          <ChannelAvatar id={channel.id} />
        </span>
      ))}
    </span>
  );
};
